/**
 * Fictora 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

export const theme = {
  popupTagBgColor: '#282825',
  popupTagColor: '#FFFFFF',
  filterBgColor: '#1F1E20',
  filterActiveBgColor: '#313031',
  filterColor: '#A5A5A5',
  filterActiveColor: '#F4F4F4',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
